<template>
    <div>
        <p>Введите данные Карты москвича, Единой карты петербуржца или промокод и получите скидку.</p>

        <div class="social-card__type" >
            <div class="radio" v-for="(item, index) in socialCardTypes" >
                <input v-model="socialCardInfo.socialCardType"
                        type="radio" class="radio__input" name="social-card" :value="item.value" :id="item.value"
                        @click="clicker"
                >
                <label :for="item.value" class="radio__label">
                    <span class="radio__icon">
                    <span class="radio__icon--pic"></span>
                    </span>
                    <span class="radio__text">{{ item.label }}</span>
                </label>
            </div>
        </div>

        <template v-if="socialCardInfo.socialCardType">
            <p>{{ fieldHint }}</p>
            <p v-if="socialCardInfo.socialCardType === 'msc'" >Для карт, cодержащих код держателя, укажите код держателя карты в поле номер, вводить серию в этом случае не нужно.</p>
            <div class="social-card__inputs" >
                <Input v-model="socialCardInfo.cardInputSerial" placeholder="Серия карты" v-if="socialCardInfo.socialCardType === 'msc'" />
                <Input v-model="socialCardInfo.cardInputNumber" :placeholder="numberInputPlaceholder" />
                <SocialCardPopup v-if="socialCardInfo.socialCardType !== 'promo'" :type="socialCardInfo.socialCardType" />
            </div>
    
            <p v-if="socialCardInfo.discount" class="social-card__hint">Скидка по {{ discountHint }} активирована</p>
        </template>
    </div>
</template>

<script>
import Input from '@/create/components/UI/inputs/Input.vue';
import SocialCardPopup from './SocialCardPopup.vue';


    export default {
        components: {
            Input,
            SocialCardPopup,
        },
        emits: ['checker'],
        props: {
            socialCardInfo: Object,
        },
        data() {
            return {
                socialCardTypes: [
                    {
                        value: 'msc',
                        label: 'Карта москвича'
                    },
                    {
                        value: 'spb',
                        label: 'Единая карта петербуржца'
                    },
                    {
                        value: 'promo',
                        label: 'Промокод'
                    },
                ],
            }
        },
        computed: {
            fieldHint() {
                if (this.socialCardInfo.socialCardType === 'msc') return 'Для карт, содержащих серию и номер, укажите серию и номер карты.'
                if (this.socialCardInfo.socialCardType === 'spb') return 'Введите данные, указанные в поле Идентификатор карты'
                if (this.socialCardInfo.socialCardType === 'promo') return 'Введите промокод'
            },
            numberInputPlaceholder() {
                if (this.socialCardInfo.socialCardType === 'msc') return 'Номер карты'
                if (this.socialCardInfo.socialCardType === 'spb') return 'Идентификатор карты'
                if (this.socialCardInfo.socialCardType === 'promo') return 'Промокод'
            },
            discountHint() {
                if (this.socialCardInfo.socialCardType === 'promo') return 'промокоду'
                else return 'карте'
            },
        },
        methods: {
            clicker(e) {
                if (this.socialCardInfo.socialCardType === e.target.value) {
                    this.$emit('checker')
                }
            }
        }
    }
</script>

<style lang="scss" scoped>
.social-card {
    &__type {
        display: flex;
        gap: 25px;
        margin: 20px 0;

        @media (max-width: 480px) {
            flex-wrap: wrap;

            .radio {
                width: 100%;
            }
        }

        .radio__icon {
            width: 30px;
            height: 30px;
            border-radius: 5px;
        }

        .radio__icon--pic {
            border-radius: 5px;
        }
    }

    &__inputs {
        margin-top: 20px;
        display: flex;
        gap: 30px;
        position: relative;

        @media (max-width: 480px) {
            flex-direction: column;
        }

        .input__container {
            width: 250px;
            
            @media (max-width: 480px) {
                width: 94%;
            }
        }

        .popup__wrapper_socCards {
            margin-left: 0;

            @media (max-width: 480px) {
                position: absolute;
                right: 0;
                top: -16px;
            }
        }
    }

    &__hint {
        color: lightseagreen;
    }
}
</style>